import React from "react";
import { Box, Stack, styled } from "convertupleads-theme";
import { grey } from "@mui/material/colors";

const CustomSwitchTrack = styled(Stack)(({ theme }) => ({
  // backgroundColor: theme.palette.grey[300],
  padding: theme.spacing(0.5, 1),
  borderRadius: "50px",
  width: "max-content",
  minWidth: "45px",
  minHeight: 23,
  maxHeight: 23,
  position: "relative",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: "12px",
  transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  "&.sw_size_small":{
    minWidth: "26px",
    minHeight: 17,
    maxHeight: 17,
    "& .sw_thumb": {
      height: "13px",
      width: "13px",
    },
    "& .sw_active": {
      width: "13px",
    },
    "&.sw_checked": {
      "& .sw_active": {
        width: "100%",
      },
      "& .sw_inactive": {
        width: "13px",
      },
    },
  },
  "& .sw_thumb": {
    height: "19px",
    width: "19px",
    borderRadius: "50%",
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    top: 2,
    left: 2,
    transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    boxShadow: theme.shadows[1],
  },
  "& .sw_active": {
    opacity: 0,
    width: "18px",
    pointerEvents: "none",
    color: theme.palette.common.white,
  },
  "& .sw_inactive": {
    opacity: 1,
    width: "100%",
    pointerEvents: "all",
  },
  "&.sw_checked": {
    // backgroundColor: theme.palette.success.main,
    "& .sw_thumb": {
      left: "unset",
      right: 2,
      boxShadow: theme.shadows[0],
    },
    "& .sw_active": {
      opacity: 1,
      width: "100%",
      pointerEvents: "all",
    },
    "& .sw_inactive": {
      opacity: 0,
      width: "18px",
      pointerEvents: "none",
    },
  },
  "&.sw_disabled": {
    pointerEvents: "none",
    opacity: 0.6,
    "& .sw_active": {
      pointerEvents: "none",
    },
    "& > *": {
      pointerEvents: "none",
    },
  },
}));

const CustomSwitch = ({
  activeText = "",
  inactiveText = "",
  size,
  checked,
  disabled,
  color,
  onChange,
}) => {
  return (
    <>
      <CustomSwitchTrack
        direction={"row"}
        alignItems={"center"}
        className={`${checked ? "sw_checked" : ""} ${
          size === "small" ? "sw_size_small" : ""
        } ${disabled ? "sw_disabled" : ""}`}
        bgcolor={checked ? color : grey[300]}
        onClick={onChange}
      >
        <Box className={"sw_thumb"}></Box>
        <span className={"sw_active"}>{activeText}</span>
        <span className={"sw_inactive"}>{inactiveText}</span>
      </CustomSwitchTrack>
    </>
  );
};

export default CustomSwitch;
